import { P2Accordion, P2Checkbox, P2TextLabel } from 'react-bootstrap-common-script'
import { TextInfo } from '../../../components/text'
import { PrivateSolicitor } from '../../../models/classes/ApplicationStep3.class'

interface ReviewPrivateSolicitorProps{
  private_solicitor: PrivateSolicitor;
  showCheckbox?: boolean;
}

function ReviewPrivateSolicitor({...props}: ReviewPrivateSolicitorProps) {

  return (
    <P2Accordion defaultOpen={true} title={<P2TextLabel bold="700" label={"Private Lawyer"} />}>
      <div>
        <TextInfo variant='column' title={"UEN of the law firm"} description={props.private_solicitor.uen} />
      </div>
      <div className='mt-4'>
        <TextInfo variant='column' title={"Name of the law firm"} description={props.private_solicitor.name_of_firm} />
      </div>
      <div className='mt-4'>
        <TextInfo variant='column' title={"Email address of the lawyer"} description={props.private_solicitor.email_of_solicitor} />
      </div>

      {!(props.showCheckbox !== undefined && !props.showCheckbox) && 
        <div className='mt-4'>
          <P2Checkbox variant={"disabled"} isActive={props.private_solicitor.represented_same_solicitor} description={<P2TextLabel tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same lawyer acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} hasTooltip label={<span className='m-0'>Conveyancing process is represented by the same lawyer as above.</span>} />} />
        </div>
      }
    </P2Accordion>
  )
}

export default ReviewPrivateSolicitor
